import { Card } from '@/components/kit';
import type { Invoice } from '@/services/api/billingApi';
import { Bar } from './Charts';
import { num } from '../lib/scope';
import { splitByBranch, useBranches } from '../lib/useManagerData';

/**
 * BY BRANCH — what each site collected, from the branch each bill was raised
 * at. One bar per branch, so a site that took nothing reads 0 rather than
 * dropping off the card.
 */
export function BranchBars({ invoices }: { invoices: Invoice[] }) {
  const branches = useBranches();
  const split = splitByBranch(invoices, branches);
  const max = Math.max(1, ...split.map((b) => b.collected));
  return (
    <Card>
      <p className="t-ovl mut mb8">By branch</p>
      {split.map((b) => (
        <Bar key={b.id ?? 'clinic'} label={b.name} value={b.collected} max={max} display={num(b.collected)} />
      ))}
      {split.length === 1 ? <p className="t-cap mut">one site — the whole month is this bar</p> : null}
    </Card>
  );
}
